const TEMPLATE_TOKEN =
  /\{\{\s*([a-zA-Z0-9_.-]+)(?:\|([a-zA-Z]+))?\s*\}\}/g;

const formatDateTime = (value: unknown): string => {
  if (value === null || value === undefined || value === "") return "-";

  const date = new Date(String(value));
  if (Number.isNaN(date.getTime()) || date.getUTCFullYear() <= 1) return "-";

  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "medium",
    timeZone: "America/Sao_Paulo"
  }).format(date);
};

export default function useFieldTemplate() {
  const formatValue = (value: unknown, format?: string): string => {
    if (format === "dateTime") return formatDateTime(value);
    if (value === null || value === undefined || value === "") return "-";

    return String(value);
  };

  const renderTemplate = (
    template: string | null | undefined,
    values: Record<string, unknown> = {}
  ): string =>
    (template ?? "").replace(
      TEMPLATE_TOKEN,
      (_token, fieldName: string, format?: string) =>
        formatValue(values[fieldName], format)
    );

  return { renderTemplate };
}
